import React, { useState } from 'react';
import { EdgeProps, getBezierPath } from '@xyflow/react';
import { useTheme, IconButton, Box } from '@mui/material';
import { X } from '@phosphor-icons/react';
import { useDispatch } from 'react-redux';
import { removeEdge } from '../../../utils/redux/slices/callStagesFlowSlice';

const CustomToolsEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  selected,
  data,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);

  // Check if delete functionality should be enabled
  const canDelete = data?.showSidebar !== false;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const handleDelete = (event: React.MouseEvent) => {
    event.stopPropagation();
    dispatch(removeEdge(id));
  };

  const showDeleteButton = canDelete && (selected || isHovered);

  return (
    <>
      {/* Main edge path */}
      <path
        id={id}
        style={{
          ...style,
          strokeDasharray: '8 4',
          stroke: selected
            ? theme.palette.primary.main
            : theme.palette.grey[400],
          strokeWidth: selected ? 3 : 2,
          cursor: 'pointer',
        }}
        className="react-flow__edge-path"
        d={edgePath}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />

      {/* Invisible wider path for easier interaction */}
      <path
        d={edgePath}
        fill="none"
        strokeOpacity={0}
        strokeWidth={20}
        className="react-flow__edge-interaction"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />

      {/* Delete button */}
      {showDeleteButton && (
        <foreignObject
          width={24}
          height={24}
          x={labelX - 12}
          y={labelY - 12}
          className="edgebutton-foreignobject"
          requiredExtensions="http://www.w3.org/1999/xhtml"
          style={{ pointerEvents: 'all' }}
        >
          <Box
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <IconButton
              onClick={handleDelete}
              size="small"
              sx={{
                width: 24,
                height: 24,
                backgroundColor: theme.palette.error.main,
                color: 'white',
                border: `2px solid ${theme.palette.background.paper}`,
                '&:hover': {
                  backgroundColor: theme.palette.error.dark,
                  transform: 'scale(1.1)',
                },
                transition: 'all 0.2s ease',
                boxShadow: theme.shadows[2],
              }}
            >
              <X size={12} weight="bold" />
            </IconButton>
          </Box>
        </foreignObject>
      )}
    </>
  );
};

export default CustomToolsEdge;
